import { Heading, TextField, Flex, Text } from '@scale/scaleui-radix';
import { AuditRubricCriterion } from '@scale/shared-types';

export const ViewCriterionName = ({
  criterion,
  renderedActions,
  showQuestionText = true,
}: {
  criterion: AuditRubricCriterion;
  renderedActions: JSX.Element | null;
  showQuestionText?: boolean;
}) => {
  return (
    <Flex direction="column" gap="2" width="100%">
      <Flex direction="row" align="center" justify="between" width="100%">
        <Heading size="2">{`Criterion: ${criterion.title}`}</Heading>
        {renderedActions}
      </Flex>
      {showQuestionText && <Text>{criterion.questionText}</Text>}
    </Flex>
  );
};

const EditCriterionName = ({
  criterion,
  setCriterion,
  error,
}: {
  criterion: AuditRubricCriterion;
  setCriterion: (criterion: AuditRubricCriterion) => void;
  error?: string;
}) => {
  return (
    <Flex direction="column" gap="2" width="100%">
      <Heading size="2">Criterion name</Heading>
      <TextField.Root
        placeholder="Criterion title"
        value={criterion.title}
        onChange={e => setCriterion({ ...criterion, title: e.target.value })}
        className="w-full"
        color={error ? 'red' : undefined}
        style={error ? { boxShadow: 'inset 0 0 0 1px #dc2626' } : undefined}
      />
      <Text> Question Text </Text>
      <TextField.Root
        placeholder="Question text"
        value={criterion.questionText}
        onChange={e => setCriterion({ ...criterion, questionText: e.target.value })}
        className="w-full"
      />
      {error && (
        <Text size="2" color="red">
          {error}
        </Text>
      )}
    </Flex>
  );
};

export const CriterionName = ({
  criterion,
  setCriterion,
  isEditingCriterion,
  renderedActions,
  error,
}: {
  criterion: AuditRubricCriterion;
  setCriterion: (criterion: AuditRubricCriterion) => void;
  isCriterionEditable: boolean;
  isEditingCriterion: boolean;
  renderedActions: JSX.Element | null;
  error?: string;
}) => {
  return isEditingCriterion ? (
    <EditCriterionName criterion={criterion} setCriterion={setCriterion} error={error} />
  ) : (
    <ViewCriterionName criterion={criterion} renderedActions={renderedActions} />
  );
};
